import React from 'react';
import closeIcon from '../images/close popup.png';
import ProcessFlowItem from '../../ProcessFlowItem';
import Button from '../../Button';
import {_SYSTEM_TITLES} from '../../../configuration/index.config';

const EditProjectPopUp = ({close, mainContent, moveNext, isCanMoveNext, createPageIndex, moveBeck, titlesProcess, sendProjectToServer}) => (
    <div className='popup-warning'>
        <div className='popup-project-edit-inner'>
            <div className='project-edit-title-container'>
                <div className='project-edit-with-close'>
                    <p className='project-edit-p'>{_SYSTEM_TITLES.createProjectData}</p>
                    <img className='project-edit-close' src={closeIcon} alt='close popup' onClick={close}/>
                </div>
                {createPageIndex < titlesProcess.length && <div className='projects-edit-flow-items'>
                    {titlesProcess.map((title, index) => {
                        const isActiveClass = () => {
                            if (index === createPageIndex) {
                                return 'active';
                            } else if (index < createPageIndex) {
                                return 'pass';
                            }

                            return 'inactive';
                        };

                        return <ProcessFlowItem
                            key={title}
                            flowItemType='flowItem-project'
                            activeClassName={isActiveClass()}
                            title={title}
                            isLast={index === ['Project Details', `${_SYSTEM_TITLES.tags}`, `${_SYSTEM_TITLES.labelsAndAttributes}`].length - 1}
                        />;
                    })}

                </div>}
            </div>
            <div className={createPageIndex < titlesProcess.length ? 'project-edit-main' : 'project-edit-summary'}>
                {mainContent()}
            </div>
            <div className='project-edit-footer'>
                <Button isDisabledActive={false} onClick={moveBeck} classNameButton={createPageIndex > 0 ? 'btn-inner' : 'btn-inner show-opacity'} >Previous</Button>
                {createPageIndex < titlesProcess.length ? <Button isDisabledActive={false} onClick={moveNext} classNameButton={!isCanMoveNext ? 'btn-main show-opacity' : 'btn-main'} >Next</Button>
                    : <Button isDisabledActive={false} onClick={sendProjectToServer} classNameButton='btn-main' >Create Project</Button>}
            </div>
        </div>
    </div>
);

export default EditProjectPopUp;
